import { useMutation, useQueryClient } from '@tanstack/react-query';

import { RegionChannelSettingPayload, createRegionChannelSetting } from '~/services/PromoService';

import { regionChannelSettingQueryKeys } from './regionChannelSettingQueryKeys';

export function useCreateRegionChannelSetting() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: RegionChannelSettingPayload) => createRegionChannelSetting(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: regionChannelSettingQueryKeys.lists() });
    },
  });
}
